import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Priority } from 'src/app/shared/services/models/totem/priority.model';
import { TotemButtonStruct } from "src/app/shared/services/structs/totem/totem-button.struct";
import { UtilsClientService } from 'src/app/client/utils.service';
import { Patient } from 'src/app/shared/services/models/medical-record/patient.model';
import { OrchestratorTotemRequest } from 'src/app/shared/services/requests/orchestrator-totem/orchestrator-totem.request';

@Component({
  selector: 'app-totem-options',
  templateUrl: './totem-options.component.html',
  styleUrls: ['./totem-options.component.css']
})
export class TotemOptionsComponent implements OnInit {

  @Input() listPriority: Priority[] = [];
  @Input() listTotemPriority: Priority[] = [];
  @Input() birthDate: Date | null = null;
  @Input() listTotemButton: TotemButtonStruct[] = [];
  @Input() state: string = '';
  @Input() isLoading: boolean = false;
  @Input() idHealthUnit: number | null = null;
  @Input() timeZoneValue: number | null = null;
  @Input() hasFacialBiometrics: boolean = false;


  @Output() onFinish: EventEmitter<any> = new EventEmitter<any>();
  @Output() populatePriorities: EventEmitter<any> = new EventEmitter<any>();

  totemButton: TotemButtonStruct = new TotemButtonStruct();
  idPatient: number | null = null;
  totemRequest: OrchestratorTotemRequest = new OrchestratorTotemRequest();
  sendSmsForUpdateAddress: boolean = false;
  idGender: number | null = null;
  idGenderIdentity: number | null = null;
  constructor(private utilsClientService: UtilsClientService) { }

  ngOnInit(): void {

  }

  selectedOption(idTotemButton: number) {
    this.totemButton = this.listTotemButton.find(x => x.idTotemButton == idTotemButton)!;
    this.state = 'identifier';
  }

  setIdPatient(patient: any) {
    if (patient) {
      this.idPatient = patient.idPatient;
      this.birthDate = patient.birthDate;
      this.idGender = patient.idGender;
      this.idGenderIdentity = patient.idGenderIdentity;
    }
    
    this.sendSmsForUpdateAddress = patient.sendSmsForUpdateAddress;
    this.state = 'priority';
  }

  backToIdPatient() {
    this.idPatient = null;
    this.birthDate = null;
    this.state = 'identifier';

    this.populatePriorities.emit();
  }

  backToOption() {
    this.totemButton = new TotemButtonStruct();
    this.state = 'options';
  }

  printToOption(prioritiesSelected: number[]) {
    this.totemRequest.idTotemButton = this.totemButton.idTotemButton;
    this.totemRequest.listPriority = prioritiesSelected;
    this.totemRequest.listTotemPriority = prioritiesSelected;
    this.totemRequest.birthDate = this.birthDate;
    this.totemRequest.idPatient = this.idPatient;
    this.totemRequest.isSchedule = this.totemButton.isScheduleToggle;
    this.totemRequest.sendSmsForUpdateAddress = this.sendSmsForUpdateAddress;
    this.totemRequest.idUserPatient = this.utilsClientService.getIdUserPatientSchedule();
    this.totemRequest.idSchedule = this.utilsClientService.getIdSchedule();
    this.onFinish.emit(this.totemRequest);
  }
}